import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { I8N, StringUtil } from "@eres/core";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { SSOApi } from "@eres/ssoapi";
import { navigate } from "@my-dld/utils/StoreUtils";
import { exToMessage } from "@eres/ssoapi/api";
import VerifyPopup from "@my-dld/components/VerifyPopup";
import { FixedMobileInput } from "@my-dld/components/FixedEidInput";
import ReCAPTCHA from "react-google-recaptcha";
import { Gated } from "@10x/feature-gate";
import { featureGateCheck } from "@my-dld/utils/Utils";

interface Props {

}

interface State {
	formErrors: { [ k: string ]: string | undefined };
	userName: string;
	email: string;
	mobile: string;
	showOTP: boolean;
	captchaResponse?: string;
	captchaError?: string;
	showCaptcha: boolean;
}

class Form extends Component<Props, State> {
	vp = React.createRef<VerifyPopup>();
	captcha = React.createRef<ReCAPTCHA>();

	constructor( props: Props ) {
		super( props );
		this.state = {
			formErrors: {},
			userName: "",
			email: "",
			mobile: "",
			showOTP: false,
			showCaptcha: window.AppInfo.noCaptcha !== true,
		};
	}

	isValid = () => {
		let isError = StringUtil.isEmptyStringOrNull( this.state.userName );
		isError = isError || ( StringUtil.isEmptyStringOrNull( this.state.mobile ) && StringUtil.isEmptyStringOrNull( this.state.email ) );
		if ( this.state.showCaptcha )
			isError = isError || ( StringUtil.isEmptyStringOrNull( this.state.captchaResponse ) );
		if ( !isError ) {
			const evs = Object.values( this.state.formErrors );
			isError = evs.filter( x => !StringUtil.isEmptyStringOrNull( x ) ).length !== 0;
		}
		return !isError;
	};

	render() {
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
		};
		const { email, mobile, formErrors, showOTP } = this.state;
		const isValid = this.isValid();
		let sm = "";
		if ( showOTP ) {
			if ( !StringUtil.isEmptyStringOrNull( mobile ) && !StringUtil.isEmptyStringOrNull( email ) )
				sm = Strings.we_have_sent_otp_to_your_mobile_email;
			else if ( !StringUtil.isEmptyStringOrNull( email ) )
				sm = Strings.we_have_sent_otp_to_your_email;
			else
				sm = Strings.we_have_sent_otp_to_your_mobile;
		}
		const forgot_password_msg = featureGateCheck("showMobileOTP") ? Strings.forgot_password_info : Strings.forgot_password_info_email_otp;
		return (
			<>
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
					<div className="sso-left-panel forgot-password-wrapper">
						<div className="form-group forgot-password-title">
							<span className="forgot-password-title-icon"/>
							{ Strings.forgot_password }
						</div>
						<TextInputField
							{ ...formProps }
							placeHolder={ Strings.username_placeholder }
							id={ "userName" }
							error={ formErrors.userName }
							label={ Strings.user_name }
							required={ true }
							maxLength={ 256 }
							onValueChange={ ( value, extra ) => {
								this.validateUserName( value );
							} }
						>
							<a
								href="#/sso/forgot/username"
								className={ "forgot-password-link" }>{ Strings.forgot_username_question }</a>
						</TextInputField>
						<div className="sso-or-div"/>
						<TextInputField
							{ ...formProps }
							placeHolder={ Strings.email_placeholder }
							id={ "email" }
							error={ formErrors.email }
							label={ Strings.email }
							required={ StringUtil.isEmptyStringOrNull( mobile ) }
							maxLength={ 256 }
							onValueChange={ ( value, extra ) => {
								this.validateEmail( value );
							} }
							onValueUpdated={ value => {
								this.validateMobile( this.state.mobile );
							} }
						/>
						<Gated featureId={"showMobileOTP"}>
							<div className="sso-or-div"><span>{ Strings.or_caps }</span></div>
							<FixedMobileInput
								{ ...formProps }
								placeHolder={ Strings.mobile_placeholder }
								id={ "mobile" }
								error={ formErrors.mobile }
								label={ Strings.mobile_number }
								required={ StringUtil.isEmptyStringOrNull( email ) }
								onValueChange={ ( value, extra ) => {
									this.validateMobile( value );
								} }
								onValueUpdated={ value => {
									this.validateEmail( this.state.email );
								} }
							/>
						</Gated>
						<div className="form-group">
							<span className="sso-agree-msg">{ forgot_password_msg }</span>
						</div>
						{ this.state.showCaptcha &&
							<div className="form-group">
								<ReCAPTCHA
									ref={ this.captcha }
									sitekey={ window.AppInfo.recaptchaSiteKey! }
									hl={ I8N.locale() }
									onChange={ this.onCaptchaChange }
									onErrored={ this.onCaptchaExpired }
									onExpired={ this.onCaptchaExpired }
								/>
								{ this.state.captchaError && <div className={ "invalid-feedback invalid-feedback-x" }>
									{ this.state.captchaError }
								</div> }
							</div>
						}
						<div className="form-group">
							<button
								disabled={ !isValid }
								onClick={ this.submit }
								className="btn btn_1 btn_style1 btn-block">{ Strings.submit_label }</button>
						</div>
					</div>
				</div>
				{ showOTP && <VerifyPopup
					ref={ this.vp }
					hideVCode={ false }
					id={ "sso_fp_otp" }
					message={ sm }
					maxLength={ 7 }
					onDismiss={ this.onVerifyDismiss }
					onVerify={ this.onVerify }
					hasResend={ true }
					resend_label={ "" }
					resend_label_link={ Strings.resend }
					onResend={ this.regenPassCode }
					loginId={ this.state.userName }
				/> }
			</>
		);
	}

	onCaptchaChange = ( token: string | null ) => {
		this.setState( { captchaResponse: token!, captchaError: undefined } );
	};
	onCaptchaExpired = () => {
		this.setState( { captchaResponse: undefined } );
	};
	resetCaptcha = () => {
		if ( this.captcha.current ) this.captcha.current.reset();
		this.setState( { captchaResponse: undefined } );
	};
	regenPassCode = () => {
		return SSOApi.forgot.resendOTP().then( r => {
			return true;
		} ).catch( e => {
			return exToMessage( e ).then( msg => {
				throw  msg.error;
			} );
		} );
	};
	onVerify = ( otp: string ) => {
		return SSOApi.forgot.verify( otp! ).then( r => {
			return () => {
				navigate( "/sso/forgot/change" );
			};
		} ).catch( e => {
			return exToMessage( e ).then( msg => {
				throw  msg.error;
			} );
		} );
	};
	onVerifyDismiss = () => {
		this.setState( { showOTP: false } );
	};
	setError = ( key: string, error: string | undefined ) => {
		this.setState( s => {
			return {
				formErrors: {
					...s.formErrors,
					[ key ]: error,
				}
			};
		} );
	};
	validateUserName = ( value: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			this.setError( "userName", Strings.form_required_label );
		} else {
			this.setError( "userName", undefined );
		}
	};
	validateMobile = ( value: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			if ( StringUtil.isEmptyStringOrNull( this.state.email ) )
				this.setError( "mobile", Strings.form_required_label );
			else
				this.setError( "mobile", undefined );
		} else if ( StringUtil.normaliseMobileNumber( value ).length < 12 ) {
			this.setError( "mobile", Strings.invalid_mobile_number );
		} else {
			this.setError( "mobile", undefined );
		}
	};
	validateEmail = ( value: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			if ( StringUtil.isEmptyStringOrNull( this.state.mobile ) )
				this.setError( "email", Strings.form_required_label );
			else
				this.setError( "email", undefined );
		} else if ( !StringUtil.isEmailAddress( value ) ) {
			this.setError( "email", Strings.invalid_email_address );
		} else {
			this.setError( "email", undefined );
		}
	};
	submit = () => {
		if ( this.state.showCaptcha && StringUtil.isEmptyStringOrNull( this.state.captchaResponse ) ) {
			this.setState( { captchaError: Strings.required } );
			return;
		}
		showLoading();
		let mobile = this.state.mobile;
		if ( !StringUtil.isEmptyStringOrNull( mobile ) )
			mobile = StringUtil.normaliseMobileNumber( mobile );
		SSOApi.forgot.init( this.state.userName, this.state.showCaptcha ? this.state.captchaResponse! : "", mobile, this.state.email ).then( r => {
			this.resetCaptcha();
			hideLoading();
			this.setState( {
				showOTP: true,
			} );
		} )
		.catch( e => {
			this.resetCaptcha();
			hideLoading();
			exToMessage( e ).then( message => {
				this.setError( "userName", message.error );
			} );
		} );
	};
}

export default Form;
